const STORAGE_KEY = 'gently:postLoginRedirect';

/** Same-origin paths only — never `//host` or an absolute URL. */
function isSafeRedirect(href: string): boolean {
  return href.startsWith('/') && !href.startsWith('//');
}

/**
 * Remember where to land after an SSO login. SSO leaves the app for the
 * provider and comes back to a fixed callback route, so the login page's
 * `?redirect=` would otherwise be lost (e.g. mid Gently MCP consent).
 */
export function rememberPostLoginRedirect(href: string | undefined): void {
  try {
    if (href && isSafeRedirect(href)) {
      sessionStorage.setItem(STORAGE_KEY, href);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage unavailable (private mode, blocked): fall back to '/'.
  }
}

/** Read and clear the remembered redirect; '/' when there is none. */
export function consumePostLoginRedirect(): string {
  try {
    const href = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return href && isSafeRedirect(href) ? href : '/';
  } catch {
    return '/';
  }
}
